// extracted by mini-css-extract-plugin
module.exports = {"infoIconContainer":"IconButton_infoIconContainer__1dUxS","disabled":"IconButton_disabled__2vg4A"};